import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { DEFAULT_ROUTER_FEATURENAME, routerReducer } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';

import { OverlayOutletEffects } from './state/overlay-outlet.effects';
import { RouterEffects } from './state/router.effects';

/**
 * Epicuro Router Store Module. Wrapper for ngrx router-store.
 */
@NgModule({
  declarations: [],
  imports: [
    RouterModule,
    StoreModule.forFeature(DEFAULT_ROUTER_FEATURENAME, routerReducer),
    EffectsModule.forFeature([RouterEffects, OverlayOutletEffects]),
  ],
})
export class RouterStoreModule {}
